module.exports = __webpack_public_path__ + "static/scale-model-of-bay-adventures-in-miami-gardens-florida-63a4890ecde1adb6e85f634c4d1aac7b.png";